<template>
  <div>
    <a-card :bordered="false" class="header-solid h-full mb-50" :bodyStyle="{ paddingTop: '12px' }"
      style="background: transparent; box-shadow: none;">
      <template #title>
        <a-row>
          <a-col :xs="24" :sm="24" :md="20" :lg="20" :xl="20">
            <h6 class="font-web f-18">
              <a @click="gotoMainType" class="mr-5"><a-icon type="arrow-left" /></a>
              แบบฟอร์มคำขออนุมัติ <span class="ml-5 text-danger font-weight-bold">Work from Home</span>
            </h6>
            <p class="form-sub-title font-web ml-20">&nbsp;&nbsp;Work from Home Request Form</p>
          </a-col>

        </a-row>
      </template>
      <!-- form -->
      <a-row :gutter="24" type="flex" align="stretch">
        <a-col :xs="24" :sm="24" :md="0" :lg="1" :xl="1"></a-col>
        <a-col :xs="24" :sm="24" :md="8" :lg="7" :xl="7" class="h-full">
          <historyRequest :dataRequest="dataHistory" textHead="Work from Home" :loadingList="loadingList"
            class="h-full" />
        </a-col>
        <a-col :xs="24" :sm="24" :md="16" :lg="15" :xl="15">
          <div class="form-container">
            <a-form class="font-web" :layout="'horizontal'">
              <a-descriptions bordered title="" size="small">
                <a-descriptions-item>
                  <div slot="label">
                    <h6 class="mt-0 mb-0 font-web">
                      เลือกวันขอปฏิบัติงานจากที่บ้าน
                      <span class="text-danger">*</span>
                    </h6>
                  </div>
                  <a-date-picker v-model="formWorkForHome.selected_date" :disabled-date="disabledHolidayDate"
                    format="YYYY-MM-DD" placeholder="" />
                </a-descriptions-item>
              </a-descriptions>

              <h6 class="mt-20 mb-10 font-web">
                รายละเอียดการทำงาน <span class="text-danger">*</span>
              </h6>
              <a-form-item>
                <a-textarea placeholder="" :auto-size="{ minRows: 3, maxRows: 5 }" v-model="formWorkForHome.detail" />
              </a-form-item>

              <h6 class="mt-20 mb-10 font-web">
                ข้อมูลการติดต่อ <span class="text-danger">*</span>
              </h6>
              <a-form-item>
                <a-textarea placeholder="" :auto-size="{ minRows: 3, maxRows: 5 }"
                  v-model="formWorkForHome.wfh_contact" />
              </a-form-item>

              <div class="mt-20 mb-20" v-if="
                this.$store.state.role.RulesUser.permissions.indexOf(
                  `IC-HRI:chief`
                ) >= 0
              ">
                <h6 class="mt-0 mb-0 font-web">
                  Upload documents ( For chief to hr ):
                  <span class="text-danger">*</span>
                </h6>
                <a-upload :file-list="fileListCheif" :remove="handleCheifRemove" :before-upload="beforeCheifUpload"
                  :multiple="false" v-model="formWorkForHome.cheifFile" accept="image/*;capture=camera">
                  <a-button class="mt-10">
                    <a-icon type="upload" /> Select File
                  </a-button>
                </a-upload>
              </div>

              <!-- text -->


              <a-form-item class="mt-0">
                <a-row>
                  <a-col :xs="{ span: 24 }" :md="{ span: 8 }">
                    <a-button type="danger" @click="clearForm">
                      <b>ยกเลิกการขอ</b>
                    </a-button>
                  </a-col>
                  <a-col :style="{ textAlign: 'right' }" :xs="{ span: 12 }" :md="{ span: 8, offset: 8 }">
                    <a-button type="primary" class="font-web pa-10" size="lg"
                      :disabled="formWorkForHome.selected_date === null" @click="dialogConfirm = true">
                      ส่งคำขออนุมัติปฎิบัติงาน Work From Home
                    </a-button>
                  </a-col>
                </a-row>
              </a-form-item>
            </a-form>
          </div>
        </a-col>
      </a-row>
    </a-card>
    <!-- dialog -->
    <a-modal title="Confirm" :visible="dialogConfirm" @ok="submitRequest" @cancel="clearForm">
      <p v-if="boxHomeError.length === 0" class="mt-10 mb-20">
        Are you sure to Submit ?
      </p>
      <a-spin v-if="loading" tip="Loading..."></a-spin>

      <div v-if="boxHomeError.length !== 0">
        <a-alert :message="`Error The date you selected cannot be redeemed ::`" type="error" show-icon class="font-web">
          <div slot="description">
            <span v-if="boxHomeError[0].msg === undefined">
              {{ boxHomeError[0] }}
            </span>
            <span v-else>{{ boxHomeError[0].msg }}</span>
          </div>
        </a-alert>
      </div>
    </a-modal>
  </div>
</template>

<script>
const form = {
  selected_date: null,
  detail: "",
  wfh_contact: "",
  cheifFile: null,
};
import historyRequest from './history_request.vue';
import { hriRequestMixin } from "@/mixins/hriRequestMixin";
export default {
  components: {
    historyRequest
  },
  data() {
    return {
      // history
      dataHomeRequest: [],
      //
      dialogConfirm: false,
      // form
      formWorkForHome: Object.assign({}, form),
      loading: false,
      // config
      dataDayNotHome: [],
      // error
      boxHomeError: [],
      //
      fileListCheif: [],
      loadingList: false,
    };
  },
  watch: {},
  mounted() {
    this.getDaySetting();
    this.getAllRequest();
  },
  mixins: [hriRequestMixin],
  methods: {
    async getAllRequest() {
      await this.loadRequestHistory('/hri/workfromhome/me/', { start: 'start', end: 'end' });
    },
    async getDaySetting() {
      this.dataDayNotHome = [];
      let nextY = this.moment().add(1, "year").format("YYYY");
      let s = this.moment(`${this.moment().format("YYYY")}-10-01`).format(
        "YYYY-MM-DD"
      );
      let e = this.moment(`${nextY}-09-30`).format("YYYY-MM-DD");
      const data = await this.fetchCalendarData(s, e);
      if (data) {
        for (let h = 0; h < data.length; h++) {
          const listD = data[h];
          if (
            !["seminar", "payday", "announce", "event", "other"].includes(
              listD.calendar_type
            )
          ) {
            this.dataDayNotHome.push(listD.extra_date);
          }
        }
      }
    },
    disabledHolidayDate(date) {
      if (
        this.moment(date).format("YYYY-MM-DD") <=
        this.moment("2026-09-30").format("YYYY-MM-DD")
      ) {
        if (
          this.moment(date).format("dddd") === "Saturday" ||
          this.moment(date).format("dddd") === "Sunday"
        ) {
          return true;
        } else {
          if (
            this.dataDayNotHome.includes(this.moment(date).format("YYYY-MM-DD"))
          ) {
            return true;
          } else {
            return false;
          }
        }
      } else {
        return true;
      }
    },
    handleCheifRemove(file) {
      this.removeFileFromList(file, 'fileListCheif');
    },
    beforeCheifUpload(file) {
      if (this.isValidFile(file)) {
        this.formWorkForHome.cheifFile = file;
        this.fileListCheif = [...this.fileListCheif, file];
      }
      return false;
    },
    clearForm() {
      this.dialogConfirm = false;
      this.formWorkForHome = Object.assign({}, form);
      this.boxHomeError = [];
    },
    async submitRequest() {
      this.boxHomeError = [];
      this.loading = true;
      const sendData = new FormData();
      sendData.append(
        "selected_date",
        this.moment(this.formWorkForHome.selected_date).format("YYYY-MM-DD")
      );
      sendData.append("detail", this.formWorkForHome.detail);
      sendData.append("wfh_contact", this.formWorkForHome.wfh_contact);
      if (
        this.$store.state.role.RulesUser.permissions.indexOf(`IC-HRI:chief`) >= 0
      ) {
        sendData.append("chief_backup", this.formWorkForHome.cheifFile);
      }
      try {
        const response = await this.$http.post(
          "/hri/workfromhome/add_request/",
          sendData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
        if (response.status === 201) {
          this.loading = false;
          this.clearForm();
          this.$success({
            title: "This is a success message",
            content: (
              <div>
                <p class="mt-0 mb-0">Success : send request Work From Home</p>
                <p class="mt-0 mb-0">(ข้อมูลของท่านถูกบันทึกเรียบร้อย)</p>
              </div>
            ),
          });
          this.$router
            .push({
              path: "/hri/",
            })
            .catch((err) => { });
        } else {
          const error = new Error('Request Failed');
          error.response = response;
          throw error;
        }
      } catch (error) {
        this.$notification.open({
          style: {
            backgroundColor: "#ff1919",
            color: "#ffffff",
          },
          message: function (h) {
            return h("div", [
              h("strong", { class: "" }, `Error ${error.response.status}`),
            ]);
          },
          description: `Problem issue connect api : /hri/workfromhome/add_request/`,
        });
        this.boxHomeError.push(error.response.data);
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.f-14 {
  font-size: 14px;
}

.spin-content {
  border: 1px solid #91d5ff;
  background-color: #e6f7ff;
  padding: 30px;
}

.form-sub-title {
  font-size: 12px;
  margin-top: 5px;
  margin-bottom: 0px;
}

.form-container {
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  padding: 24px;
  height: 100%;
  background: #ffffff;
}

.h-full {
  height: 100%;
}
</style>